<template>
		<div id="pageRoot">

			<label class="toggleButtonContainer pageElement" id="toggle01">MARIPOSA
				<input type="radio"
				name="mariposa"
				ref="1-1" 
				v-on:change="saveOption('radios', 1, 1)" 
				:onload="loadOption('radios', 1, 1)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle02">MARTILLO
				<input type="radio"
				name="mariposa"
				ref="1-2" 
				v-on:change="saveOption('radios', 1, 2)" 
				:onload="loadOption('radios', 1, 2)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle03">MARACA
				<input type="radio"
				name="mariposa"
				ref="1-3" 
				v-on:change="saveOption('radios', 1, 3)" 
				:onload="loadOption('radios', 1, 3)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle04">MAR
				<input type="radio"
				name="mariposa"
				ref="1-4" 
				v-on:change="saveOption('radios', 1, 4)" 
				:onload="loadOption('radios', 1, 4)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle05">TACHUELA
				<input type="radio"
				name="techo"
				ref="2-1" 
				v-on:change="saveOption('radios', 2, 1)" 
				:onload="loadOption('radios', 2, 1)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle06">TECHO
				<input type="radio"
				name="techo"
				ref="2-2" 
				v-on:change="saveOption('radios', 2, 2)" 
				:onload="loadOption('radios', 2, 2)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle07">TICHOLO
				<input type="radio"
				name="techo"
				ref="2-3" 
				v-on:change="saveOption('radios', 2, 3)" 
				:onload="loadOption('radios', 2, 3)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle08">TACHO
				<input type="radio"
				name="techo"
				ref="2-4" 
				v-on:change="saveOption('radios', 2, 4)" 
				:onload="loadOption('radios', 2, 4)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle09">MALO
				<input type="radio"
				name="maceta"
				ref="3-1" 
				v-on:change="saveOption('radios', 3, 1)" 
				:onload="loadOption('radios', 3, 1)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle10">MACETA
				<input type="radio"
				name="maceta"
				ref="3-2" 
				v-on:change="saveOption('radios', 3, 2)" 
				:onload="loadOption('radios', 3, 2)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle11">MANZANA
				<input type="radio"
				name="maceta"
				ref="3-3" 
				v-on:change="saveOption('radios', 3, 3)" 
				:onload="loadOption('radios', 3, 3)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle12">MACACO
				<input type="radio"
				name="maceta"
				ref="3-4" 
				v-on:change="saveOption('radios', 3, 4)" 
				:onload="loadOption('radios', 3, 4)">
				<span class="toggleButton"></span>
			</label>

			<div id="butterfly" class="basicItem01">		
				<img src="/pages/img/sordo/svgPage64Butterfly.svg" class="pageElement" style=" width: 100%; height: 100%;">
			</div>
			<div id="roof" class="basicItem01">		
				<img src="/pages/img/sordo/svgPage64Roof.svg" class="pageElement" style=" width: 100%; height: 100%;">
			</div>
			<div id="pot" class="basicItem01">		
				<img src="/pages/img/sordo/svgPage64Pot.svg" class="pageElement" style=" width: 100%; height: 100%;">
			</div>

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<span class="footer-page footer-read"></span>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
#butterfly{
/* butterfly */
position: absolute;
left: 7.03%;
right: 76.51%;
top: 14.06%;
bottom: 63.2%;
}
#roof{
/* roof */
position: absolute;
left: 6.45%;
right: 73.67%;
top: 56.12%;
bottom: 27.04%;
}
#pot{
/* maceta */
position: absolute;
left: 54.39%;
right: 33.62%;
top: 38.15%;
bottom: 44.74%;
}
#toggle01{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 282px;
top: 97.86px;
z-index: 3;

}
#toggle02
{/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 282px;
top: 151.95px;
z-index: 3;
}
#toggle03{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 282px;
top: 205.09px;
z-index: 3;
}
#toggle04
{/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 282px;
top: 259.18px;
z-index: 3;
}
#toggle05{
/* Ellipse 4 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 282px;
top: 400.86px;
z-index: 3;
}
#toggle06{
/* Ellipse 5 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 282px;
top: 454.95px;
z-index: 3;
}
#toggle07{
/* Ellipse 6 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 282px;
top: 508.09px;
z-index: 3;
}
#toggle08{
/* Ellipse 7 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 282px;
top: 562.18px;
z-index: 3;
}
#toggle09{/* Ellipse 8 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 724px;
top: 260.86px;
z-index: 3;
}

#toggle10{/* Ellipse 9 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 724px;
top: 314.95px;
z-index: 3;
}
#toggle11{
/* Ellipse 10 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 724px;
top: 368.09px;
z-index: 3;
}
#toggle12{
/* Ellipse 11 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 724px;
top: 422.18px;
z-index: 3;
}

</style>
<script>
  export default {
	data() {
			return {
				videos: ["p63-65/V41.mp4", "p63-65/V42.mp4"],
			};
		},	

    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>